function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ic_bettwaesche");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.958 1.792v28.417h18.083v-28.417h-18.083zM5.667 0.5h20.667v31h-20.667v-31z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.542 14.708v12.917h12.917v-12.917h-12.917zM8.25 13.417h15.5v15.5h-15.5v-15.5z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.458 4.375v-1.292l1.292 1.292h-1.292zM22.458 4.375h-9.558c-0.713 0-1.292-0.578-1.292-1.292h12.142v7.75h-15.5v-7.75h1.292v6.458h12.917v-5.167zM22.458 9.542h1.292l-1.292 1.292v-1.292zM9.542 9.542v1.292l-1.292-1.292h1.292zM9.542 9.542v1.292l-1.292-1.292h1.292zM9.542 9.542h12.917v-5.167h-9.558c-0.713 0-1.292-0.578-1.292-1.292h12.142v7.75h-15.5v-7.75h1.292v6.458zM22.458 9.542h1.292l-1.292 1.292v-1.292zM22.458 4.375v-1.292l1.292 1.292h-1.292z"
});

var SvgProductBedLinen = function SvgProductBedLinen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductBedLinen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_bed-linen.bd88e770.svg";
export { ForwardRef as ReactComponent };